module.exports = __webpack_public_path__ + "static/media/berattelse.c632ff1a.mp3";